import * as React from 'react';
import ProjectListContainer from './ProjectList.container';
import { connect } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import './Projects.css';

interface StateProps {
  locationHash: string | undefined;
}

interface Props extends StateProps {
}

class ProjectsComponent extends React.PureComponent<Props> {

  private portfolioRef: HTMLAnchorElement | null;

  constructor(props: Props) {
    super(props);
    this.portfolioRef = null;
    this.onLoadProjects = this.onLoadProjects.bind(this);
  }

  public render(): React.ReactNode {

    return (
      <section className="projects-screen">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3 className="bold-subtitle">
                Oportunidades de inversión abiertas
              </h3>
            </div>
          </div>
          <div className="gap-30"/>
          <ProjectListContainer
            status="open"
            listKey="openProjects"
            isSimple={false}
            onLoadProjects={this.onLoadProjects}
          />
        </div>
        <a 
          ref={(ref) => this.portfolioRef = ref}
          id="portfolio"
        />
        <div className="gap-50"/>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h3 className="bold-subtitle">Nuestro portfolio</h3>
              <div className="gap-20" />
              <ProjectListContainer
                status="closed"
                listKey="closedProjects"
                isSimple={false}
                onLoadProjects={this.onLoadProjects}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }

  private onLoadProjects(): void {
    if (this.props.locationHash && this.portfolioRef && this.props.locationHash === '#portfolio') {
      window.scrollTo(0, this.portfolioRef.offsetTop);
    }
  }
}

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
  locationHash: state.router.location ? state.router.location.hash : undefined,
});

export default connect(mapStateToProps)(ProjectsComponent);


// WEBPACK FOOTER //
// ./src/modules/projects/Projects.component.tsx